<template>
	<div class="tabsbar_warp flex flex-x-between">
		<div class="left_arrow">
			<img src="@/assets/images/icon-double-arrow-left.png" alt="" srcset="" />
		</div>
		<div class="tabs">
			<div class="tab" v-for="(item, i) in tabs" :key="i" :class="{ active: tabsIndex == i }"
				@click="toUrl(item, i)">
				<span>{{ item.text }}</span>
				<span class="iconfont icon-guanbi2fill col-666 fontSize16" v-if="tabs.length > 1"
					@click.stop="removeTabs(item, i)"></span>
			</div>
		</div>
		<div class="close_button fontSize14 col-333" @click="closeTabs()">关闭</div>
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		nextTick,
		onBeforeMount
	} from "vue";
	import {
		onBeforeRouteUpdate,
		useRouter,
		useRoute
	} from "vue-router";
	import {
		useStore
	} from "vuex";

	export default defineComponent({
		setup() {
			const router = useRouter();
			const route = useRoute();
			const store = useStore();
			console.log(store.state.tabsIndex);

			const tabs = computed(() => store.state.tabsList);
			const tabsIndex = computed(() => store.state.tabsIndex);

			console.log(tabsIndex, "tabsIndex");
			const removeTabs = (item2, i) => {
				const index = store.state.keeptabsList.findIndex(item => item === item2.attributes.url)
				if (index !== -1) {
					store.state.keeptabsList.splice(index, 1);
				}

				console.log(i);
				if (i > 0) {
					i = i - 1;
				}
				console.log(i);
				let tabs = store.state.tabsList.filter((el) => {
					return el.id.indexOf(item2.id) === -1;
				});
				let item1 = tabs[i];
				console.log(item1);
				router.push({
					name: item1.attributes.url,
					replace: true,
				});
				store.commit("handleTabsIndex", i);
				store.commit("handleTabsList", tabs);
			};
			const closeTabs = () => {
				store.state.keeptabsList=[];
				router.push({
					name: "adminIndex",
					replace: true,
				});
				store.commit("handleTabsIndex", 0);
				store.commit("handleTabsList", []);
			};
			const toUrl = (item, i) => {
				if (i == store.state.tabsIndex) {
					console.log("----");
					return;
				}
				store.commit("handleTabsIndex", i);
				router.push({
					name: item.attributes.url,
					replace: true,
				});
			};
			onBeforeMount(() => {});

			return {
				tabsIndex,
				tabs,
				removeTabs,
				closeTabs,
				toUrl,
			};
		},
	});
</script>

<style scoped>
	.tabsbar_warp {
		width: 100%;
		height: 41px;
		background: #ffffff;
		box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
	}

	.left_arrow {
		width: 50px;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.left_arrow img {
		width: 11px;
		cursor: pointer;
	}

	.close_button {
		width: 60px;
		height: 100%;
		border-left: 1px solid rgba(125, 125, 125, 0.18);
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tabs {
		width: calc(100% - 60px - 50px);
		height: 100%;
		text-align: left;
		white-space: nowrap;
		overflow-x: auto;
	}

	.tabs .tab:first-child {
		border-left: 1px solid rgba(125, 125, 125, 0.18);
	}

	.tab {
		width: 150px;
		height: calc(100% - 1px);
		background: #ffffff;
		color: #999999;
		font-size: 12px;
		cursor: pointer;
		border-top: 1px solid rgba(125, 125, 125, 0.18);
		border-right: 1px solid rgba(125, 125, 125, 0.18);
		display: inline-flex;
		align-items: center;
		justify-content: space-around;
	}

	.tabs .tab.active {
		background: rgba(54, 76, 116, 0.1) !important;
		color: #2c3e50 !important;
	}
</style>